export const checkIfPWAInstalled = () => {
  // Проверяем для iOS
  if ('standalone' in navigator && navigator.standalone) {
    return true
  }

  // Проверяем для других платформ (Android, Chrome)
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true
  }

  return false
}
